// ==================================================================================== SECTION 3
// ========================================== SHUFFLE
document.addEventListener("DOMContentLoaded", function() {
  const articlesContainer = document.querySelector('.co-article-section-3-grid');
  const articles = Array.from(articlesContainer.querySelectorAll('.co-article-section-3-grid-item'));
  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }
  const shuffledArticles = shuffle(articles);
  articlesContainer.innerHTML = '';
  shuffledArticles.slice(0, 3).forEach(article => {
    articlesContainer.appendChild(article);
  });
});
// ========================================== FLICKITY

// document.querySelector('.recipe-print-btn')?.addEventListener('click', function () {
//   // --- 1. Get logo (use Shopify CDN resize to keep intrinsic size small) ---
//   const logoEl = document.querySelector('header img[src*="logo"], .header img[src*="logo"]');
//   let logoSrc = logoEl?.src || 'https://eatsimpli.com/cdn/shop/files/Simpli-logo-adjusted.png?v=1726600088&width=600';
//   logoSrc = logoSrc.replace(/&width=\d+/, '').replace(/\?width=\d+&?/, '?') + '&width=240';

//   // --- 2. Get recipe title ---
//   const titleEl = document.querySelector('.co-article-recipes-section-1-text h1') 
//     || document.querySelector('article h1') 
//     || document.querySelector('h1');
//   const recipeTitle = titleEl ? titleEl.textContent.trim() : 'Recipe';

//   // --- 3. Parse ingredient groups ---
//   const ingredientsContainer = document.querySelector('.co-article-recipes-section-2-col-1-frame');
//   if (!ingredientsContainer) return;

//   let ingredientsHTML = '';
//   const grids = ingredientsContainer.querySelectorAll('.co-article-recipes-section-2-grid');

//   grids.forEach((grid) => {
//     const groupTitle = grid.previousElementSibling;
//     if (groupTitle && groupTitle.tagName === 'H3') {
//       ingredientsHTML += `<h3>${groupTitle.textContent.trim()}</h3>`;
//     }

//     const names = grid.querySelectorAll('.co-article-recipes-section-2-grid-item-1-1');
//     const amounts = grid.querySelectorAll('.co-article-recipes-section-2-grid-item-1-2');

//     const namesByRow = {};
//     const amountsByRow = {};

//     names.forEach((el) => {
//       const row = el.style.gridRowStart;
//       const h5 = el.querySelector('h5');
//       if (row && h5) namesByRow[row] = h5.textContent.trim();
//     });

//     amounts.forEach((el) => {
//       const row = el.style.gridRowStart;
//       const h6 = el.querySelector('h6');
//       if (row && h6) amountsByRow[row] = h6.textContent.trim();
//     });

//     const rows = Object.keys(namesByRow).sort((a, b) => parseInt(a) - parseInt(b));
//     rows.forEach((row) => {
//       const name = namesByRow[row] || '';
//       const amount = amountsByRow[row] || '';
//       ingredientsHTML += `
//         <div class="ingredient-row">
//           <span class="ingredient-name">${name}</span>
//           <span class="ingredient-amount">${amount}</span>
//         </div>`;
//     });
//   });

//   // --- 4. Parse instructions ---
//   const instructionsEl = document.querySelector('.co-article-recipes-section-2-col-2-frame .metafield-rich_text_field');
//   const instructionsHTML = instructionsEl ? instructionsEl.innerHTML : '';

//   // --- 5. Open print window ---
//   const printWindow = window.open('', '_blank', 'width=800,height=600');
//   printWindow.document.write(`
//     <!DOCTYPE html>
//     <html>
//     <head>
//       <title>Print: ${recipeTitle}</title>
//       <style>
//         @page { margin: 0.5in; }
//         * { margin: 0; padding: 0; box-sizing: border-box; }
//         body {
//           font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif;
//           color: #1a1a1a;
//           line-height: 1.5;
//         }
//         .print-wrapper {
//           display: block;
//         }
//         .print-header {
//           text-align: center;
//           border-bottom: 2px solid #1a1a1a;
//           padding-bottom: 10px;
//           margin-bottom: 16px;
//         }
//         .print-logo {
//           display: inline-block;
//           width: 120px;
//           height: auto;
//           margin-bottom: 8px;
//         }
//         .print-header h1 {
//           font-size: 20px;
//           text-transform: uppercase;
//           letter-spacing: 2px;
//         }
//         .print-columns {
//           display: flex;
//           gap: 32px;
//         }
//         .print-col-left { flex: 0 0 42%; }
//         .print-col-right { flex: 1; }

//         h2 {
//           font-size: 13px;
//           text-transform: uppercase;
//           letter-spacing: 1.5px;
//           border-bottom: 1px solid #ccc;
//           padding-bottom: 5px;
//           margin-bottom: 12px;
//         }
//         h3 {
//           font-size: 12px;
//           font-weight: 600;
//           margin: 14px 0 6px;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }
//         .print-col-left h3:first-of-type { margin-top: 0; }

//         .ingredient-row {
//           display: flex;
//           justify-content: space-between;
//           align-items: baseline;
//           padding: 3px 0;
//           border-bottom: 1px dotted #ddd;
//           font-size: 12px;
//         }
//         .ingredient-name { flex: 1; padding-right: 8px; }
//         .ingredient-amount {
//           flex-shrink: 0;
//           font-style: italic;
//           color: #555;
//           text-align: right;
//         }

//         .print-col-right h3 {
//           font-size: 13px;
//           margin: 14px 0 6px;
//         }
//         .print-col-right h3:first-of-type { margin-top: 0; }
//         .print-col-right ol {
//           padding-left: 18px;
//           margin-bottom: 6px;
//         }
//         .print-col-right li {
//           font-size: 12px;
//           margin-bottom: 4px;
//           line-height: 1.5;
//         }
//         .print-col-right li strong { font-weight: 600; }
//       </style>
//     </head>
//     <body>
//       <div class="print-wrapper">
//         <div class="print-header">
//           <img src="${logoSrc}" class="print-logo" alt="SIMPLi" />
//           <h1>${recipeTitle}</h1>
//         </div>
//         <div class="print-columns">
//           <div class="print-col-left">
//             <h2>Ingredients</h2>
//             ${ingredientsHTML}
//           </div>
//           <div class="print-col-right">
//             <h2>Instructions</h2>
//             ${instructionsHTML}
//           </div>
//         </div>
//       </div>
//     </body>
//     </html>
//   `);

//   printWindow.document.close();
//   printWindow.focus();

//   const logoImg = printWindow.document.querySelector('.print-logo');
//   if (logoImg && !logoImg.complete) {
//     logoImg.onload = function () {
//       printWindow.print();
//       printWindow.close();
//     };
//     logoImg.onerror = function () {
//       printWindow.print();
//       printWindow.close();
//     };
//   } else {
//     printWindow.print();
//     printWindow.close();
//   }
// });

document.querySelector('.recipe-print-btn')?.addEventListener('click', function () {
  // --- 1. Get logo (use Shopify CDN resize to keep intrinsic size small) ---
  const logoEl = document.querySelector('header img[src*="logo"], .header img[src*="logo"]');
  let logoSrc = logoEl?.src || 'https://eatsimpli.com/cdn/shop/files/Simpli-logo-adjusted.png?v=1726600088&width=600';
  logoSrc = logoSrc.replace(/&width=\d+/, '').replace(/\?width=\d+&?/, '?') + '&width=240';

  // --- 2. Get recipe title ---
  const titleEl = document.querySelector('.co-article-recipes-section-1-text h1') 
    || document.querySelector('article h1') 
    || document.querySelector('h1');
  const recipeTitle = titleEl ? titleEl.textContent.trim() : 'Recipe';

  // --- 3. Parse ingredient groups ---
  const ingredientsContainer = document.querySelector('.co-article-recipes-section-2-col-1-frame');
  if (!ingredientsContainer) return;

  let ingredientsHTML = '';
  const grids = ingredientsContainer.querySelectorAll('.co-article-recipes-section-2-grid');

  grids.forEach((grid) => {
    const groupTitle = grid.previousElementSibling;
    if (groupTitle && groupTitle.tagName === 'H3') {
      ingredientsHTML += `<h3>${groupTitle.textContent.trim()}</h3>`;
    }

    const names = grid.querySelectorAll('.co-article-recipes-section-2-grid-item-1-1');
    const amounts = grid.querySelectorAll('.co-article-recipes-section-2-grid-item-1-2');

    const namesByRow = {};
    const amountsByRow = {};

    names.forEach((el) => {
      const row = el.style.gridRowStart;
      const h5 = el.querySelector('h5');
      if (row && h5) namesByRow[row] = h5.textContent.trim();
    });

    amounts.forEach((el) => {
      const row = el.style.gridRowStart;
      const h6 = el.querySelector('h6');
      if (row && h6) amountsByRow[row] = h6.textContent.trim();
    });

    const rows = Object.keys(namesByRow).sort((a, b) => parseInt(a) - parseInt(b));
    rows.forEach((row) => {
      const name = namesByRow[row] || '';
      const amount = amountsByRow[row] || '';
      ingredientsHTML += `
        <div class="ingredient-row">
          <span class="ingredient-name">${name}</span>
          <span class="ingredient-amount">${amount}</span>
        </div>`;
    });
  });

  // --- 4. Parse instructions ---
  const instructionsEl = document.querySelector('.co-article-recipes-section-2-col-2-frame .metafield-rich_text_field');
  const instructionsHTML = instructionsEl ? instructionsEl.innerHTML : '';

  // --- 5. Open print window ---
  const printWindow = window.open('', '_blank', 'width=800,height=600');
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>Print: ${recipeTitle}</title>
      <style>
        @page { margin: 0.5in; }
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body {
          font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif;
          color: #1a1a1a;
          line-height: 1.5;
        }
        .print-wrapper {
          display: block;
        }
        .print-header {
          text-align: center;
          border-bottom: 2px solid #1a1a1a;
          padding-bottom: 10px;
          margin-bottom: 16px;
        }
        .print-logo {
          display: inline-block;
          width: 120px;
          height: auto;
          margin-bottom: 8px;
        }
        .print-header h1 {
          font-size: 20px;
          text-transform: uppercase;
          letter-spacing: 2px;
        }
        .print-header .print-info {
          font-size: 11px;
          color: #666;
          letter-spacing: 0.5px;
          margin-top: 4px;
        }
        .print-header .print-info span {
          margin: 0 6px;
        }
        .print-link {
          color: #666;
          text-decoration: none;
        }
        .print-columns {
          display: flex;
          gap: 32px;
        }
        .print-col-left { flex: 0 0 42%; }
        .print-col-right { flex: 1; }

        h2 {
          font-size: 13px;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          border-bottom: 1px solid #ccc;
          padding-bottom: 5px;
          margin-bottom: 12px;
        }
        h3 {
          font-size: 12px;
          font-weight: 600;
          margin: 14px 0 6px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        .print-col-left h3:first-of-type { margin-top: 0; }

        .ingredient-row {
          display: flex;
          justify-content: space-between;
          align-items: baseline;
          padding: 3px 0;
          border-bottom: 1px dotted #ddd;
          font-size: 12px;
        }
        .ingredient-name { flex: 1; padding-right: 8px; }
        .ingredient-amount {
          flex-shrink: 0;
          font-style: italic;
          color: #555;
          text-align: right;
        }

        .print-col-right h3 {
          font-size: 13px;
          margin: 14px 0 6px;
        }
        .print-col-right h3:first-of-type { margin-top: 0; }
        .print-col-right ol {
          padding-left: 18px;
          margin-bottom: 6px;
        }
        .print-col-right li {
          font-size: 12px;
          margin-bottom: 4px;
          line-height: 1.5;
        }
        .print-col-right li strong { font-weight: 600; }
      </style>
    </head>
    <body>
      <div class="print-wrapper">
        <div class="print-header">
          <img src="${logoSrc}" class="print-logo" alt="SIMPLi" />
          <h1>${recipeTitle}</h1>
          <div class="print-info">
            <span>eatsimpli.com</span>
            <span>&middot;</span>
            <a href="https://www.instagram.com/eatsimpli/" class="print-link">@eatsimpli</a>
          </div>
        </div>
        <div class="print-columns">
          <div class="print-col-left">
            <h2>Ingredients</h2>
            ${ingredientsHTML}
          </div>
          <div class="print-col-right">
            <h2>Instructions</h2>
            ${instructionsHTML}
          </div>
        </div>
      </div>
    </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();

  const logoImg = printWindow.document.querySelector('.print-logo');
  if (logoImg && !logoImg.complete) {
    logoImg.onload = function () {
      printWindow.print();
      printWindow.close();
    };
    logoImg.onerror = function () {
      printWindow.print();
      printWindow.close();
    };
  } else {
    printWindow.print();
    printWindow.close();
  }
});